module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chaptitle"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "pagexi"
    }
  }), _c('b', [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/preface#rpr",
      "id": "pr",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/introduction#rin",
      "id": "in"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', [_vm._v("Chapter")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/ch01#rch1",
      "id": "ch1"
    }
  }, [_vm._v("1.  Recruiting the Volunteers, 1861")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch02#rch2",
      "id": "ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.  The Organization of the Cavalry, 1862")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch03#rch3",
      "id": "ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.  Food and Clothing")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch04#rch4",
      "id": "ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.  Arms and Mounts")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch05#rch5",
      "id": "ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.  Campaigning: Cane Hill and Prairie Grove")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch06#rch6",
      "id": "ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.  Raiding Federal Missouri")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch07#rch7",
      "id": "ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.  Closing Scenes")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part1#rp1",
      "id": "p1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendices")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/app1#rapp1",
      "id": "app1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix A.  List of Confederate Cavalry Regiments and Battalions from the Trans-Mississippi")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/app2#rapp2",
      "id": "app2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix B.  Total Strength of Cavalry Units Raised in the Trans-Mississippi")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/app3#rapp3",
      "id": "app3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix C.  Organization of Price’s Cavalry Corps")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/bib#rbib",
      "id": "bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/index#rind",
      "id": "ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0faf4820","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 75
// module chunks = 0